import React from "react";
import { Textfit } from "react-textfit";
const EmbText = ({
    discountMessage,
    embroideryPricing,
    inputText,
    defaultText,
    calcText = false,
    setHasOverflowText,
    hasOverflowText,
    embRefPreviewText,
    embRefPreviewContainer,
  }) => {
    const textToPreview = inputText.replace(/\s/g, "\u00a0");
  
    // for calculating overflow text
    if (calcText) {
      return (
        <>
          {textToPreview !== ""
            ? [...textToPreview].map((c, i) => <span key={`${c}-${i}`}>{c}</span>)
            : [...defaultText].map((c, i) => <span key={`${c}-${i}`}>{c}</span>)}
        </>
      );
    }
  
    // check if the text needs to use TextFit component
    return (
      <>
        {hasOverflowText ? (
          <Textfit
            onReady={() =>
              setHasOverflowText(
                embRefPreviewText?.current?.offsetWidth >
                  embRefPreviewContainer?.current?.offsetWidth
              )
            }
            mode="single"
            max={160}
          >
            {textToPreview !== ""
              ? [...textToPreview].map((c, i) => (
                  <span key={`${c}-${i}`}>{c}</span>
                ))
              : [...defaultText].map((c, i) => (
                  <span key={`${c}-${i}`}>{c}</span>
                ))}
          </Textfit>
        ) : (
          <div>
            <div>
              {textToPreview !== ""
                ? [...textToPreview].map((c, i) => (
                    <span key={`${c}-${i}`}>{c}</span>
                  ))
                : [...defaultText].map((c, i) => (
                    <span key={`${c}-${i}`}>{c}</span>
                  ))}
            </div>
          </div>
        )}
      </>
    );
  };
  export default EmbText; 